import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { translate as t } from 'hooks/useTranslations';
import { AppContext } from 'views/App/context';
import { enqueueSnackbar } from 'notistack';
import ComplianceChecklist from 'views/App/Portal/AWB/_components/ComplianceChecklist';
import useComplianceItemsOrg from '../../../_data_sources/ComplianceItems/useComplianceItemsOrg';

export interface ComplianceChecklistTabContentProps {
  standardId: string;
}

const ComplianceChecklistTabContent: React.FC<ComplianceChecklistTabContentProps> = ({ standardId }) => {
  const { id: accreditationId, versionId } = useParams();
  const { currentOrganizationId, isFeatureEnabled, hasPermission } = useContext(AppContext);

  const {
    data: items = [],
    isLoading,
    createItemAsync,
    updateItemAsync,
    isCreatingItem,
    isUpdatingItem,
  } = useComplianceItemsOrg(
    accreditationId ?? '',
    versionId ?? '',
    standardId,
    {},
    (err: any) => {
      let message = 'Error';
      try {
        const parsed = JSON.parse(err?.message ?? '');
        message = parsed?.errorDetails?.[0]?.detail ?? parsed?.detail ?? parsed?.message ?? 'Error';
      } catch {
        message = err?.detail ?? err?.message ?? 'Error';
      }
      enqueueSnackbar(message, { variant: 'error' });
    }
  );

  if (
    (!hasPermission('awbPremium', currentOrganizationId) && !isFeatureEnabled('awbPremiumDemo')) ||
    !accreditationId ||
    !versionId
  ) {
    return null;
  }

  return (
    <ComplianceChecklist
      items={items}
      isLoading={isLoading}
      isCreatingItem={isCreatingItem}
      isUpdatingItem={isUpdatingItem}
      currentOrganizationId={currentOrganizationId ?? undefined}
      onSaveEdit={(id, html) =>
        updateItemAsync({ complianceItemId: id, updates: { draftContent: html } }).then(() =>
          enqueueSnackbar(t('awb.complianceChecklist.lexipolTemplate.snackbar.itemUpdated'), { variant: 'success' })
        )
      }
      onToggleCompleted={(id, completed) =>
        updateItemAsync({ complianceItemId: id, updates: { completed } }).then(() =>
          enqueueSnackbar(t('awb.complianceChecklist.statusUpdated'), { variant: 'success' })
        )
      }
      onToggleEnabled={(id, enabled) =>
        updateItemAsync({ complianceItemId: id, updates: { enabled } }).then(() =>
          enqueueSnackbar(t('awb.complianceChecklist.lexipolTemplate.snackbar.itemEnabledToggled'), {
            variant: 'success',
          })
        )
      }
      onSaveNewItem={(html, position) =>
        createItemAsync({ position, draftContent: html }).then(() =>
          enqueueSnackbar(t('awb.complianceChecklist.lexipolTemplate.snackbar.itemAdded'), { variant: 'success' })
        )
      }
    />
  );
};

export default ComplianceChecklistTabContent;
